import React, {
  useEffect,
  useState
} from 'react';
import {
  Box,
  Container,
  makeStyles
} from '@material-ui/core';

import Toolbar from './toolbar';
import Results from './results';
import configs from '../../configs';
import Page from '../../components/Page';
import firebaseUtility from '../../utils/firebase.utils';


const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));
const Reports = () => {
  const classes = useStyles();
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [lastItem, setLastItem] = useState(null);
  const [firstItem, setFirstItem] = useState(null);
  const [page, setPage] = useState(0);
  const [report, setReport] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [moreResult, setMoreResult] = useState(true);


  useEffect(() => {
    (async () => {
      // eslint-disable-next-line no-use-before-define
      await getReports();
    })();
  }, []);

  const getReports = async (prev = false, size = pageSize) => {
    setLoading(true);
    let reportsDocs;
    if (prev) {
      reportsDocs = await firebaseUtility.GetPrevPageAllDocuments(
        'reports',
        size,
        firstItem,
        'createAt',
        'desc'
      );
    } else {
      reportsDocs = await firebaseUtility.GetNextPageAllDocuments(
        'reports',
        size,
        'createAt',
        'desc'
      );
    }

    setReports(reportsDocs);
    setFirstItem(reportsDocs[0]);
    setLastItem(reportsDocs[reportsDocs.length - 1]);
    setLoading(false);
  };


  const searchUsersMethod = async (text, searchType) => {
    if (text === '') {
      await getReports();
      return;
    }
    setLoading(true);
    const searchKey = searchType == 'reporterUid' ? 'reporterUid' : 'reportedUser.uid';
    firebaseUtility.Firestore().collection('reports').where(searchKey, '==', text).get()
      .then(result => {
        setReports(result.docs.map(i => {
          return {
            ...i.data(),
            id: i.id
          }
        }))
      }).catch(err => {
        console.log(err);
      })
    setLoading(false);
  };


  const handlePageSizeChange = async (size) => {
    setLoading(true);
    if (pageSize != size) {
      setPageSize(size);
      await getReports(false, size);
    }
    setLoading(false);
  };

  const handlePageChange = async (pageIndex) => {
    setLoading(true);
    if (pageIndex < page) {
      await getReports(true);
    } else {
      await getReports(false);
    }
    setPage(pageIndex);
    setLoading(false);
  };

  return ( 
  <Page className = {
      classes.root
    }
    title = "Reports" >
    <Container maxWidth = {
      false
    } >
    <Toolbar searchUsersMethod = {
      searchUsersMethod
    }
    isLoading = {
      loading
    }
    /> 
    <Box mt = {
      3
    }>
    <Results pageIndex = {
      page
    }
    reports = {
      reports
    }
    isLoading = {
      loading
    }
    pageSizeIndex = {
      pageSize
    }
    setPageSize = {
      (size) => {
        handlePageSizeChange(size);
      }
    }
    pageChanged = {
      (pageIndex) => {
        handlePageChange(pageIndex);
      }
    }
    /> 
    </Box> 
    </Container> 
    </Page>
  );
};

export default Reports;
